import { apiCall } from './api-call';
import { getAnalytics } from '../../common/analytics';

const form = document.getElementsByClassName('survey-page__form')[0];
const input = document.getElementsByClassName('survey-page__input')[0];
const errorMessage = document.getElementsByClassName(
  'survey-page__error-message'
)[0];
const surveyButton = document.getElementsByClassName('survey-page__button')[0];
const processingText =
  global.translations.messages['common.forms.buttons.pending'];

form &&
  form.addEventListener('submit', event => {
    event.preventDefault();
    processingState();

    const inputValue = document.getElementsByClassName('survey-page__input')[0]
      .value;
    const payload = JSON.stringify({ code: inputValue });

    apiCall('/survey/check-code', 'PUT', payload).always(res => {
      if (res.url) {
        track(inputValue, res.message, () => (window.location = res.url));
      } else {
        resetForm();
        track(inputValue, res.message);
        invalidState();
      }
    });
  });

input &&
  input.addEventListener('keydown', function(x) {
    let code = this.value;
    const deleteCode = 46;
    const backspaceCode = 8;
    const enterCode = 13;
    const dashPosition = 4;
    const maxLength = 9;

    if (
      x.keyCode === deleteCode ||
      x.keyCode === backspaceCode ||
      x.keyCode === enterCode
    ) {
      return;
    }

    // Manage the inoput behaviour around where we inject the `-`
    if (
      (code.length !== dashPosition && x.key === '-') ||
      code.length >= maxLength
    ) {
      x.preventDefault();
    }

    if (
      code.length >= dashPosition &&
      code[dashPosition] !== '-' &&
      x.key !== '-'
    ) {
      code = `${code.slice(0, dashPosition)}-${code.slice(dashPosition)}`;
    }
    this.value = code;
  });

function track(code, message, callback) {
  getAnalytics().track(
    'Submit',
    {
      code,
      message,
    },
    callback
  );
}

function resetForm() {
  surveyButton.value = 'Submit';
  surveyButton.removeAttribute('disabled');
}

function processingState() {
  errorMessage.classList.add('hide');
  surveyButton.value = processingText;
  surveyButton.setAttribute('disabled', 'disabled');
}

function invalidState() {
  errorMessage.classList.remove('hide');
}
